import React, { FC, useCallback, useEffect, useRef } from 'react';

import DataGrid, {
  Column,
  ColumnChooser,
  Export,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  StateStoring,
  Summary,
  TotalItem,
} from 'devextreme-react/data-grid';

import moment from 'moment';

import { AppCard } from 'components/appComponents';
import { MONEY_FORMAT } from 'constants/formats';
import { Button, Template } from 'devextreme-react';

import { useLazyGetComingNomenclatureFareQuery } from 'bus/comingNomenclatureMain/services/main';

import { ComingNomenclatureFareInfo } from './components';
import { onExporting } from './utils';

type Props = {
  dateBegin: string;
  dateEnd: string;
  transportName: string;
  transportId: number | null;
};

const MainList: FC<Props> = ({ dateBegin, dateEnd, transportId, transportName }) => {
  //const { data } = useSelector((store) => store.comingNomenclatureMain.fare);
  const refGrid = useRef<DataGrid | null>(null);

  const [getComingNomenclatureFare, { data }] = useLazyGetComingNomenclatureFareQuery();

  const salaryDataStore = useCallback(async () => {
    if (transportId) {
      await getComingNomenclatureFare({
        transportId,
        dateBegin,
        dateEnd,
      });
    }
  }, [dateBegin, dateEnd, getComingNomenclatureFare, transportId]);

  useEffect(() => {
    salaryDataStore();
  }, [salaryDataStore]);

  const dateBeginText = moment(dateBegin).format('DD.MM.YYYY');
  const dateEndText = moment(dateEnd).format('DD.MM.YYYY');

  const onExportingHandler = () => {
    if (!data) return;
    onExporting(refGrid, data, transportName, {
      dateBeginText,
      dateEndText,
    });
  };

  const refresh = () => salaryDataStore();

  return (
    <div className="container-dev">
      <ComingNomenclatureFareInfo
        adjustments={data?.adjustments || 0}
        balance={data?.balance || 0}
        dateBegin={dateBeginText}
        dateEnd={dateEndText}
        outBalance={data?.outBalance || 0}
        pay={data?.pay || 0}
        toPay={data?.toPay || 0}
      />
      <AppCard>
        <DataGrid
          dataSource={data?.data}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          key="id"
          ref={refGrid}
          onExporting={onExportingHandler}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
          onToolbarPreparing={(e) => {
            e.toolbarOptions?.items?.unshift({
              location: 'after',
              template: 'refresh',
            });
          }}
        >
          <Template name="refresh">
            <Button icon="refresh" onClick={refresh} />
          </Template>
          <StateStoring enabled={true} type="localStorage" storageKey="comingNomenclatureFare" />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <GroupPanel visible={true} />
          <ColumnChooser enabled={true} />
          <Column dataField="date" caption="Дата" dataType="date" width={120} />
          <Column dataField="object" caption="Карьер" />
          <Column dataField="nomenclature" caption="Груз" width={160} />
          <Column dataField="count" caption="Кол-во рейсов" width={120} />
          <Column dataField="price" caption="Цена" width={160} format={MONEY_FORMAT} />
          <Column dataField="total" caption="Сумма" width={160} format={MONEY_FORMAT} />
          <Column dataField="adjustments" caption="Корректировка" width={160} />
          <Column dataField="cashFlow" caption="Касса" width={160} />
          <Export enabled={true} />
          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
          <Summary>
            <TotalItem column="count" summaryType="sum" displayFormat="{0}" />
            <TotalItem column="total" summaryType="sum" displayFormat="{0}" />
            <TotalItem column="adjustments" summaryType="sum" displayFormat="{0}" />
            <TotalItem column="cashFlow" summaryType="sum" displayFormat="{0}" />
          </Summary>
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default MainList;
